import { AxiosResponse } from "axios"
import Schema from "validate"

import { request } from "../../request"
import { VehicleData } from "./hook"
import { ValuationResponse } from "./types"
import { GroupIdWeightingMapping } from "../../../utils/group-utils"

const vehicleValuationSchema = new Schema({
  subscriberId: {
    type: String,
  },
  password: {
    type: String,
  },
  group: {
    type: Number,
  },
  vehicle: {
    vehicleType: {
      type: Number,
      required: true,
    },
    capId: Number,
    capCode: String,
    mileage: Number,
    dateRegistered: String,
    condition: Number,
  },
})

const valuationConfig = {
  vehicle: {}
}

export const getValuationRequest = async (
  vehicleDetails: VehicleData,
  group: number
): Promise<AxiosResponse<ValuationResponse.RootObject>> => {
  const data = {
    ...valuationConfig,
    group: GroupIdWeightingMapping[group],
    vehicle: vehicleDetails,
  }

  const errors = vehicleValuationSchema.validate(data)

  if (errors && errors.length) {
    throw new Error("Schema is invalid")
  }

  return request({
    url: "/api/v1/weightings/cap-weighting-calculation",
    method: "post",
    headers: {
      "Access-Control-Request-Methods": "*",
      "Access-Control-Allow-Origin": "*",
    },
    data,
  })
}
